import type { NavigationItem } from '../client/components/NavBar/NavBar';
import { routes } from 'wasp/client/router';
import {
  BlogUrl,
  articlesUrl,
  discussionsUrl,
  todayUrl,
} from '../shared/common';
import avatarPlaceholder from '../client/static/avatar-placeholder.webp';

export const landingPageNavigationItems: NavigationItem[] = [
  { name: 'Features', to: '#features' },
  { name: 'Pricing', to: routes.PricingPageRoute.to },
  { name: 'Blog', to: BlogUrl },
  { name: 'Daily Briefing', to: routes.TodayRoute.to },
  { name: 'Articles', to: routes.ArticlesRoute.to },
  { name: 'Trends', to: routes.TrendsRoute.to },
  { name: 'Discussions', to: routes.DiscussionsRoute.to },
];
export const features = [
  {
    name: 'Curated Positive News',
    description:
      'Stay informed with carefully selected uplifting news stories that matter.',
    icon: '📰',
    href: articlesUrl,
  },
  {
    name: 'Community Discussions',
    description:
      'Engage in meaningful conversations about positive developments and solutions.',
    icon: '💭',
    href: discussionsUrl,
  },
  {
    name: 'Weekly Newsletter',
    description:
      'Get a weekly digest of the most inspiring news and community highlights.',
    icon: '✉️',
    href: '#newsletter',
  },
  {
    name: 'Multi-language Support',
    description: 'Access optimistic news in English and German.',
    icon: '🌍',
    href: '#',
  },
];
export const testimonials = [
  {
    name: 'Sarah Chen',
    role: 'Community Leader',
    avatarSrc: avatarPlaceholder,
    socialUrl: '#',
    quote:
      "This platform has transformed how I consume news. It's refreshing to focus on progress and solutions.",
  },
  {
    name: 'Dr. Michael Roberts',
    role: 'Psychology Professor',
    avatarSrc: avatarPlaceholder,
    socialUrl: '#',
    quote:
      'A much-needed antidote to doom scrolling. The community discussions are particularly enlightening.',
  },
  {
    name: 'Emma Thompson',
    role: 'Newsletter Subscriber',
    avatarSrc: avatarPlaceholder,
    socialUrl: '#',
    quote: 'The weekly newsletter has become my favorite Sunday morning read!',
  },
];

export const faqs = [
  {
    id: 1,
    question: 'What makes your news curation different?',
    answer:
      'We focus on progress, solutions, and positive developments while maintaining journalistic integrity.',
  },
  {
    id: 2,
    question: 'How do you ensure news accuracy?',
    answer:
      'We  only share news from reputable outlets, with clear attribution and fact-checking.',
  },
  {
    id: 3,
    question: 'Can I contribute to discussions?',
    answer:
      'Yes! All registered members can participate in discussions and share their perspectives.',
  },
];
export const footerNavigation = {
  app: [
    { name: 'Blog', href: BlogUrl },
    { name: 'Articles', href: articlesUrl },
    { name: 'Discussions', href: discussionsUrl },
    { name: 'Newsletter', href: '#newsletter' },
  ],
  company: [
    { name: 'About', href: '/about' },
    { name: 'Privacy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
    { name: 'Impressum', href: '/impressum' },
  ],
};
